<template>
  <div v-if="info" class="property-container">
    <section class="banner">
      <img :src="info.banner" alt="" />
    </section>
    <section class="main">
      <section class="sec-01">
        <img class="sec-01-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_background@2x.png" />
        <p class="sec-01-content">当前，全球经济面临资本、能源等传统动能不足的制约。摆脱全球发展困境需要新的生产力，发展新质生产力既是推动我国高质量发展的内在要求和重要着力点，又是中国为全球发展提供的新方案。在新时代新形势下，客观要求必须以发展新技术、新智造、新金融等新质生产力为突破口，全面激活形成高质量发展的新动能，引领国内高质量发展，参与全球竞争，提升国际竞争力。</p>
      </section>
      <section class="sec-02">
        <img class="sec-02-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_objective@2x.png" />
        <p class="sec-02-content">本次论坛聚焦新质生产力赋能高质量发展，理论家、经济学家、金融家和企业家代表相聚一堂，深入探讨新金融、新智造的发展方向、需求和特点，为新智造企业如何更好地获得精准、有效的金融服务，进一步发展新质生产力建言献策，助力我国经济高质量发展。</p>
      </section>
      <section
        class="sec-03">
        <div class="content">
          <div class="part part-1">
            <img
              src="https://scheme.timesmedia.com.cn/activity/metting-2024/banner_content@2x.png"
              alt=""
            />
          </div>
          <div
            v-for="(item, index) in sec03List"
            :key="index"
            class="part part-other"
            :class="'part-' + Number(index + 2)"
          >
            <p>{{ item }}</p>
          </div>
        </div>
        <div class="introduce">
          <img class="introduce-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_introduction_zhidao@2x.png" />
          <div>
            <div class="introduce-item">
              <p class="introduce-item-title">中国国家创新与发展战略研究会</p>
              <p class="introduce-item-content">前身为“国家创新与发展战略研究会”，由中国著名理论家、战略家郑必坚发起创立并担任会长，著名科学家路甬祥担任荣誉顾问。2022年11月28日经国务院批准为国家一级法人社团，业务主管单位为中国科学院。与中国人民外交学会、北京市、广东省人民政府及国际著名智库合作，创办“读懂中国”国际会议，迄今已成功举办七届，先后有来自世界各国数百位政治家、战略家和企业家参会，成为世界了解中国发展战略最具影响力的平台之一。</p>
            </div>
          </div>
        </div>
        <div class="introduce">
          <img class="introduce-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_introduction_zhuban@2x.png" />
          <div>
            <div class="introduce-item">
              <p class="introduce-item-title">广东时代传媒集团有限公司</p>
              <p class="introduce-item-content">广东时代传媒集团有限公司（简称：时代传媒集团）于2020年9月，由广东时代传媒有限公司和广东新周刊杂志社有限公司合并组建，是南方出版传媒股份有限公司（股票简称：南方传媒；股票代码：601900）的全资子公司，是以报刊出版、新媒体内容及广告运营为主营业务，致力于建设集报刊、新媒体、品牌活动、图书出版为一体的优质全媒体传播平台。</p>
            </div>
            <div class="introduce-item">
              <p class="introduce-item-title">广东省省情调查研究中心</p>
              <p class="introduce-item-content">广东省省情调查研究中心于2003年成立，2017年被省委宣传部评定为省重点智库，2023年成为改制进入省出版集团，是省委财经办合作共建智库、省委办公厅信息报送单位。以“关注民生，影响决策，服务社会”为宗旨，面向各级党委政府和企事业单位，聚焦公共政策、营商环境、政务服务、公共服务、社会治理和区域与产业经济等领域，提供第三方专业调查、评估评价和决策咨询等智库服务，拥有“粤省情发布”《广东省情内参》《广东省情调查报告》等第三方权威发声渠道，相关成果得到省委、省政府主要领导的高度重视和多次批示。</p>
            </div>
          </div>
        </div>
      </section>
      <section class="sec-04">
        <img class="sec-04-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_guests@2x.png" />
        <div class="sec-04-content">
          <div v-for="(item, index) in sec04List" :key="index" class="content-item">
            <p class="content-item-name">{{ item.name }}</p>
            <p class="content-item-summary">{{ item.summary }}</p>
          </div>
        </div>
      </section>
      <section class="sec-05">
        <img class="sec-05-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_process@2x.png" />
        <div class="sec-05-content">
          <div v-for="(item, index) in sec05List" :key="index" class="content-item">
            <span class="content-item-left">{{ item.time }}</span>
            <div class="content-item-right">
              <p>{{ item.label }}</p>
              <div v-if="item.summary.length" class="right-summary">
                <p v-for="(v, i) in item.summary" :key="i">{{ v }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section 
        v-if="(info.information.banner && info.information.banner.length) || (info.information.arts && info.information.arts.length) || (info.retrospects && info.retrospects.length)"
        class="sec-06">
        <img
          class="sec-06-title"
          src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_news@2x.png"
          alt=""
        />
        <div class="container-inner">
          <div class="swiper-container">
            <div
              v-if="info.information.banner && info.information.banner.length"
              class="swiper-box"
            >
              <swiper
                style="width: 100%; height: 488px"
                :options="swiperOption">
                <swiper-slide
                  @click.native="onLink(item.link)"
                  class="swiper-slide"
                  v-for="(item, index) in info.information.banner"
                  :key="index"
                >
                  <div class="swiper-img-wrap">
                    <img :src="item.banner" alt="" />
                  </div>
                  <div class="swiper-item-text">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.summary }}</p>
                  </div>
                </swiper-slide>
                <!-- 分页器 -->
                <div class="swiper-pagination" slot="pagination"></div>
                <!-- 左右箭头 -->
                <div
                  @click.stop
                  class="swiper-button-prev"
                  slot="button-prev"
                ></div>
                <div
                  @click.stop
                  class="swiper-button-next"
                  slot="button-next"
                ></div>
              </swiper>
            </div>
          </div>
          <div
            class="relative-news"
            v-if="info.information.arts && info.information.arts.length"
          >
            <h3>相关新闻</h3>
            <ul class="news-list">
              <li
                v-for="(item, index) in info.information.arts"
                :key="index"
                @click="onLink(item.link)"
              >
                <p>{{ item.title }}</p>
                <span class="time-icon-two">{{ item.ago }}</span>
              </li>
            </ul>
          </div>
          <div v-if="info.retrospects && info.retrospects.length" class="review-news">
            <img class="review-news-title" src="https://scheme.timesmedia.com.cn/activity/metting-2024/title_enterprise@2x.png" />
            <swiper
              style="width: 100%;padding-bottom: 40px"
              :options="swiperOptionByOld">
              <swiper-slide
                v-for="(item, index) in info.retrospects"
                class="swiperSlideByOld"
                @click="onLink(item.link)"
                :key="index">
                <h3>{{ item.title }}</h3>
                <p v-html="item.summary" />
              </swiper-slide>
              <!-- 分页器 -->
              <div class="swiper-pagination-old" slot="pagination"></div>
            </swiper>
          </div>
        </div>
      </section>
      <section class="sec-07">
        <img :src="info.setting_banner" />
      </section>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: null,
      swiperOption: {
        //显示分页
        pagination: {
          el: ".swiper-pagination",
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: false,
      },
      swiperOptionByOld: {
        //显示分页
        pagination: {
          el: ".swiper-pagination-old",
        },
        loop: false,
      },
      sec03List: [
        '从理论、政策、制度、产业和人才等角度探讨我国发展新质生产力的优势、短板及弱项，分析我国如何构建符合新质生产力发展需求的生产关系、有利于新质生产力发展的营商环境和创新生态。',
        '促进畅通科技—金融—产业循环。探讨如何以数字化、智能化、绿色化技术改造传统产业，实现传统产业转型升级；如何促进先进产业创新发展，主动布局发展战略性新兴产业和未来产业；如何创新打造科技金融、数字金融、绿色金融，形成符合新质生产力发展需求的新金融体系。',
        '促进企业向“新”发展。从新质生产力视角助力企业发展，探讨新质企业的主要特征和发展方式，挖掘产业科技互促双强的典型案例和优秀经验。'
      ],
      sec04List: [
        { 
          name: '李君如',
          summary: '中国国家创新与发展战略研究会学术委员会常务副主席、原中央党校副校长'
        },
        {
          name: '黄奇帆',
          summary: '中国国家创新与发展战略研究会学术委员会常务副主席、重庆市原市长'
        },
        {
          name: '徐伟新',
          summary: '中国国家创新与发展战略研究会会长兼学术委员会常务副主席、原中央党校副校长'
        },
        {
          name: '王博永',
          summary: '中国国家创新与发展战略研究会副会长兼秘书长    '
        },
        {
          name: '吕本富',
          summary: '中国国家创新与发展战略研究会副会长、中国科学院大学教授、网络经济学家'
        },
        {
          name: '于海峰',
          summary: '广东财经大学副书记、校长'
        },
        {
          name: '田丰',
          summary: '广东省社会科学联合会原主席、广东省政协原常委'
        },
        {
          name: '王福亮',
          summary: '广东省政协委员、广东省工商联副主席、广东省民营经济国际合作商会会长、福达集团董事局主席'
        },
        {
          name: '罗志恒',
          summary: '粤开证券首席经济学家、研究院院长'
        },
        {
          name: '程东允',
          summary: '中航美丽集团副董事长'
        },
        {
          name: '唐诗',
          summary: '光峰科技副总裁'
        },
        {
          name: '任少峰',
          summary: '趣丸科技副总裁、总编辑'
        },
        // {
        //   name: '李海超',
        //   summary: '上海证券党委书记、董事长'
        // },
      ],
      sec05List: [
        {
          time: '13:30-14:00',
          label: '嘉宾入场',
          summary: []
        },
        {
          time: '16:35-17:25',
          label: '圆桌论坛',
          summary: [
            '主题：新质生产力如何促进经济高质量发展'
          ]
        },
        {
          time: '14:00-14:15',
          label: '开幕致辞',
          summary: []
        },
        {
          time: '17:25-17:35',
          label: '《2024广东企业新质生产力发展调研报告》发布',
          summary: []
        },
        {
          time: '14:15-16:35',
          label: '主题演讲',
          summary: [
            '主题一：发展新质生产力，关键在人才，基础在教育',
            '主题二：新质生产力的逻辑内涵和实施路径',
            '主题三：新质生产力的“新”与“质”',
            '主题四：发展新质生产力的实践逻辑与实施路径：财税金融视角',
            '主题五：湾区向新，质造之都'
          ]
        },
        {
          time: '17:35-17:50',
          label: '闭幕致辞',
          summary: []
        },
        // {
        //   time: '17:45-17:50',
        //   label: '指导单位代表总结发言',
        //   summary: []
        // },
      ],
      markList: [
        {
          label: '中国平安',
          content: '2023年3月，中国平安与广汽集团达成了战略合作，面向广汽埃安合作经销商，提供库融、结算等综合金融服务，并充分发掘汽车产业链各个场景的融资需求；平安产险服务广汽集团品牌6个，提供新车、续保、个人非车险等多样化车险服务。这是平安依托综合金融优势，支持战略性新兴产业发展的一个缩影。平安产险聚焦新质生产力发展和现代化产业体系建设，为芯片、航天航空、人工智能等专精特新产业成长保驾护航，同时创新推出知识产权保险、研发费用损失保险、网络安全保险等，支持科技企业稳健经营。平安资管以债权投资计划形式投向新一代基础设施、半导体、新能源汽车等行业的累计投资规模已超400亿元。截至2024年一季度末，平安银行科技企业客户数27059户，较年初增加630户；日均存款4586亿元，较年初增长6.7%；贷款余额1218亿元，较年初增长24%。'
        },
        {
          label: '中国平安2',
          content: '2023年3月，中国平安与广汽集团达成了战略合作，面向广汽埃安合作经销商，提供库融、结算等综合金融服务，并充分发掘汽车产业链各个场景的融资需求；平安产险服务广汽集团品牌6个，提供新车、续保、个人非车险等多样化车险服务。这是平安依托综合金融优势，支持战略性新兴产业发展的一个缩影。平安产险聚焦新质生产力发展和现代化产业体系建设，为芯片、航天航空、人工智能等专精特新产业成长保驾护航，同时创新推出知识产权保险、研发费用损失保险、网络安全保险等，支持科技企业稳健经营。平安资管以债权投资计划形式投向新一代基础设施、半导体、新能源汽车等行业的累计投资规模已超400亿元。截至2024年一季度末，平安银行科技企业客户数27059户，较年初增加630户；日均存款4586亿元，较年初增长6.7%；贷款余额1218亿元，较年初增长24%。'
        },
        {
          label: '中国平安3',
          content: '2023年3月，中国平供库融059户，较年初增加630户；日均存款4586亿元，较年初增长6.7%；贷款余额1218亿元，较年初增长24%。'
        },
        {
          label: '中国平安4',
          content: '2023年3月，中国平安与提供库融、结算等综合金融服务，并充分发掘汽车产业链各个场景的融资需求；平安产险服务广汽集团品牌6个，提供新车、续保、个人非车险等多样化车险服务。这是平安依托综合金融优势，支持战略性新兴产业发展的一个缩影。平安产险聚焦新质生产力发展和现代化产业体系建设，为芯片、航天航空、人工智能等专精特新产业成长保驾护航，同时创新推出知识产权保险、研发费用损失保险、网络安全保险等，支持科技企业稳健经营。平安资管以债权投资计划形式投向新一代基础设施、半导体、新能源汽车等行业的累计投资规模已超400亿元。截至2024年一季度末，平安银行科技企业客户数27059户，较年初增加630户；日均存款4586亿元，较年初增长6.7%；贷款余额1218亿元，较年初增长24%。'
        },
      ]
    };
  },
  methods: {
    getTopicsInfo() {
      const { forum_id = null } = this.$route.query;

      this.$api.topics.getTopicsInfo({ forum_id }).then((res) => {
        if (res.status === "success") {
          this.info = res.data;
          document.title = this.info.title;
        }
      });
    },
    onLink(link = null) {
      console.info(275)
      if (!link) {
        return;
      }

      window.open(link);
    },
  },
  created() {
    this.getTopicsInfo();
  },
};
</script>

<style lang="scss" scoped>
// @font-face {
//   font-family: DIN;
//   src: url("../../assets/font/DIN-Bold.otf");
// }
p,
h1,
h2,
h3 {
  padding: 0;
  margin: 0;
}
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}
img {
  max-width: unset;
  max-height: unset;
}
.property-container {
  width: 100%;
  // background: rgba(250, 250, 250, 1);
  background: url('https://scheme.timesmedia.com.cn/activity/metting-2024/bg@2x.png') no-repeat;
  background-size: 100% 100%;
  .banner {
    position: relative;
    z-index: 999;
    img {
      width: 100%;
    }
  }
  .main {
    width: 1200px;
    margin: -20px auto 0;
    background: rgba(255, 255, 255, 1);
    .sec-07 {
      width: 100%;
      > img {
        display: block;
        width: 100%;
      }
    }
    .sec-06 {
      background: #fff;
      &-title {
        width: 100%;
      }
    }
    .sec-05 {
      width: 100%;
      height: 580px;
      padding: 110px 100px 0;
      background: url('https://scheme.timesmedia.com.cn/activity/metting-2024/bg_img_process@2x.png') no-repeat;
      background-size: 100% 100%;
      margin-top: -70px;
      &-title {
        display: block;
        width: 188px;
        margin-bottom: 30px;
      }
      &-content {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .content-item {
          display: flex;
          align-items: flex-start;
          width: 48%;
          margin-bottom: 25px;
          &-left {
            margin-right: 26px;
            font-weight: bold;
            font-size: 21px;
            color: #111111;
            line-height: 22px;
          }
          &-right {
            flex: 1;
            font-weight: bold;
            font-size: 18px;
            color: #006CF2;
            line-height: 22px;
            .right-summary {
              margin-top: 15px;
              > p {
                font-weight: 400;
                font-size: 13px;
                color: #111111;
                line-height: 14px;
                &:not(:last-child) {
                  margin-bottom: 10px;
                }
              }
            }
          }
        }
      }
    }
    .container-inner {
      padding: 26px 100px 65px;
    }

    .relative-news h3 {
      font-size: 16px;
      color: #343434;
      line-height: 24px;
      margin: 24px 0 18px;
      padding-left: 14px;
      display: flex;
      align-items: center;
    }
    .relative-news h3:before {
      content: "";
      width: 4px;
      height: 14px;
      background: #407afa;
      position: relative;
      left: -14px;
    }
    .news-list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
    }
    .news-list li {
      width: 30%;
      padding-bottom: 15px;
      cursor: pointer;
    }
    .news-list li:nth-child(3n-1) {
      margin: 0 25px;
      padding: 0 24px;
      border-left: 1px solid rgba(222, 222, 222, 1);
      border-right: 1px solid rgba(222, 222, 222, 1);
      width: 35%;
    }

    .news-list li p {
      padding: 15px 0;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #444444;
      line-height: 24px;
      width: 300px;
    }
    .news-list li:nth-child(-n + 3) p {
      padding: 0 0 15px;
    }
    .news-list li:nth-last-child(-n + 3) {
      padding-bottom: 0;
    }

    .time-icon-two {
      font-size: 15px;
      color: #9a9a9a;
      display: inline-flex;
      align-items: center;
    }
    .time-icon-two:before {
      content: "";
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../../assets/img/property/icon_time.png") no-repeat;
      background-size: cover;
      margin-right: 8px;
    }

    .sec-04 {
      position: relative;
      padding: 0 100px 10px;
      z-index: 2;
      &-title {
        display: block;
        width: 111px;
        margin-bottom: 25px;
      }
      &-content {
        width: calc(100% + 200px);
        height: 180px;
        padding-top: 10px;
        margin-left: -100px;
        overflow-y: hidden;
        overflow-x: auto;
        scroll-behavior: smooth;
        white-space: nowrap;
        user-select: none;
        .content-item {
          vertical-align: top;
          display: inline-block;
          width: 250px;
          height: 150px;
          padding: 26px 25px 0;
          background: #FFFFFF;
          box-shadow: 0px 0px 20px 0px rgba(206,226,238,0.3);
          &:not(:last-child) {
            margin-right: 20px;
          }
          &:first-child {
            margin-left: 100px;
          }
          &:last-child {
            margin-right: 100px;
          }
          &-name {
            margin-bottom: 12px;
            font-weight: bold;
            font-size: 18px;
            color: #006CF2;
            line-height: 24px;
          }
          &-summary {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 18px;
            word-wrap: break-word;
            white-space: normal;
            text-align: justify;
          }
        }
      }
    }
    .sec-03 {
      padding: 78px 100px 62px;
      .content {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        padding-bottom: 24px;
        .part {
          position: relative;
          width: 50%;
          margin-bottom: 48px;
          &:before {
            content: "";
            display: inline-block;
            height: 19px;
            width: 36px;
            position: absolute;
            left: 0;
            top: 3px;
          }
          p {
            font-size: 16px;
            color: #333333;
            line-height: 26px;
            text-align: justify;
            width: 423px;
          }
          &.part-1 img {
            height: 129px;
          }
          &.part-other {
            padding-left: 54px;
            box-sizing: border-box;
          }
          &.part-2:before {
            background: url("https://scheme.timesmedia.com.cn/activity/metting-2024/num_1@2x.png") no-repeat;
            background-size: cover;
          }
          &.part-3:before {
            background: url("https://scheme.timesmedia.com.cn/activity/metting-2024/num_2@2x.png") no-repeat;
            background-size: cover;
          }
          &.part-4:before {
            background: url("https://scheme.timesmedia.com.cn/activity/metting-2024/num_3@2x.png") no-repeat;
            background-size: cover;
          }
        }
      }
      .introduce {
        &:not(:last-child) {
          margin-bottom: 57px;
        }
        &-title {
          display: block;
          width: 100%;
          margin-bottom: 25px;
        }
        .introduce-item {
          &:not(:last-child) {
            margin-bottom: 34px;
          }
          &-title {
            font-weight: bold;
            font-size: 20px;
            color: #111111;
            line-height: 24px;
            margin-bottom: 10px;
          }
          &-content {
            font-weight: 400;
            font-size: 14px;
            color: #333333;
            line-height: 20px;
          }
        }
      }
    }
    .sec-01 {
      width: 100%;
      padding: 79px 100px 67px;
      &-title {
        display: block;
        width: 154px;
        margin-bottom: 29px;
      }
      &-content {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 28px;
      }
    }
    .sec-02 {
      position: relative;
      width: 100%;
      height: 247px;
      padding: 58px 100px 0;
      background: url('https://scheme.timesmedia.com.cn/activity/metting-2024/bg_objective@2x.png') no-repeat;
      background-size: 100% 100%;
      &::after {
        content: '';
        position: absolute;
        width: 90px;
        height: 96px;
        background: url('https://scheme.timesmedia.com.cn/activity/metting-2024/img_yinhao@2x.png') no-repeat;
        background-size: 100% 100%;
        right: 100px;
        top: -26px;
        z-index: 1;
      }
      &-title {
        display: block;
        width: 121px;
        margin-bottom: 38px;
      }
      &-content {
        font-weight: 400;
        font-size: 16px;
        color: #333333;
        line-height: 28px;
      }
    }

    .review-news {
      margin-top: 80px;
      &-title {
        display: block;
        width: 100%;
        margin-bottom: 25px;
      }
      .swiperSlideByOld {
        cursor: default;
        h3 {
          font-weight: bold;
          font-size: 20px;
          color: #111111;
          line-height: 24px;
          margin-bottom: 10px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          line-height: 20px;
          text-align: justify;
          word-break: break-all;
          white-space: normal;
        }
      }
    }

    // 轮播图
    .swiper-item-text {
      width: 500px;
      position: absolute;
      bottom: 40px;
      left: 60px;
    }
    .swiper-item-text h3 {
      font-size: 18px;
      color: #ffffff;
      line-height: 24px;
      margin-bottom: 11px;
    }
    .swiper-item-text p {
      font-size: 14px;
      color: #ffffff;
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .swiper-img-wrap {
      width: 100%;
      height: 488px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      position: relative;
    }
    .swiper-img-wrap:after {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      background: url("../../assets/img/property/news_banner_mask.png")
        no-repeat;
      background-size: cover;
    }
    .swiper-img-wrap img {
      width: 100%;
      max-height: unset;
      position: relative;
    }
  }
}
</style>
